import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "log-out",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.logOut && _ctx.logOut(...args)))
  }, [
    _cache[1] || (_cache[1] = _createElementVNode("span", { class: "material-symbols-outlined" }, " logout ", -1)),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('userComponent.logOut')), 1)
  ]))
}